import React, { Component, Fragment } from 'react';
import { ReactSVG } from 'react-svg';
import Media from 'react-media';
import { getAnalytics, logEvent } from 'firebase/analytics';

import { MOBILE_WIDTH } from '../../constants';
import styles from './Intro.module.scss';
import iosSvg from '../../assets/iosDownload.svg';
import googleBadge from '../../assets/googleBadge.png';
import appIcon from '../../assets/appIcon.png';

class Intro extends Component {
	render() {
		const { container, brand, brandSM, intro, detail, introSM, detailSM, badge, icn, icnSM, image } = styles;
		const analytics = getAnalytics();

		return (
			<Media query={{ maxWidth: MOBILE_WIDTH }}>
				{(matches) => (
					<div className={container}>
						<div className={`${matches ? brandSM : brand}`}>
							<div className={`${matches ? icnSM : icn}`}>
								<img src={appIcon} width='100%' height='100%' className={image} alt='' />
							</div>
							<div>Wake: Goal & Habit Tracker</div>
						</div>

						<Fragment>
							<div className={`${matches ? introSM : intro}`}>Better patterns make a better you.</div>
							<div className={`${matches ? detailSM : detail}`}>Stop sleepwalking through life.</div>
						</Fragment>

						<div style={{ display: 'flex', paddingTop: '5rem' }}>
							{matches ? (
								<Fragment>
									<button
										onClick={() => {
											logEvent(analytics, 'IntroIosPressed');

											window.location.href = 'https://appurl.io/zDDmpAjotI';
										}}
									>
										<ReactSVG src={iosSvg} />
									</button>
									<button
										onClick={() => {
											logEvent(analytics, 'IntroDroidPressed');

											window.location.href = 'https://appurl.io/zDDmpAjotI';
										}}
									>
										<img style={{ border: 'none', height: '4rem' }} src={googleBadge} alt='google badge' />
									</button>
								</Fragment>
							) : (
								<div className={`${matches ? detailSM : detail}`}>Available on iOS and Android</div>
							)}
						</div>
					</div>
				)}
			</Media>
		);
	}
}

export default Intro;
